import util from '@bmp-vue/core/api/util';

const controller = 'Bancos';

export default Object.assign({}, util.GetCrud(controller, null));
